import { Typography } from "@mui/material";

export const TutorialMediaPlaceholder = () => {
  return (
    <Typography
      variant="h4"
      sx={{
        width: "100%",
        height: "100%",
        color: "text.secondary",
        // Typography is a block by default, so centering the placeholder
        // inside its reserved media area needs its own flex context.
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      No Media
    </Typography>
  );
};
